<template>
  <div>
    <el-table
      :data="fileList"
      style="width: 100%;overflow: auto"
      :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
      ref="table"
      v-show="!disabled"
    >
      <el-table-column
        type="index"
        width="50"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="name"
        label="附件类型">
        <template slot-scope="scope">
          <div style="display: flex">
            <div v-if="scope.row.isRequired == '1'" style="color: red;font-size: 16px; margin-right: 3px">*</div>
            {{scope.row.name}}
          </div>

        </template>
      </el-table-column>
      <el-table-column
        prop="remarks"
        label="上传要求及说明">
      </el-table-column>
      <el-table-column
        prop="type"
        label="附件上传">
        <template slot-scope="scope">
          <!-- <div style="display: flex"> -->
            <DragAndParseUpload v-model="scope.row.fileList" :isShowTip="false" />
            <!-- <div v-if="scope.row.isRequired == '1'" style="color: red;font-size: 25px">*</div> -->
          <!-- </div> -->

        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="fileList"
      style="width: 100%;overflow: auto"
      :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
      ref="table"
      v-show="disabled"
    >
      <el-table-column
        type="index"
        width="50"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="name"
        label="附件类型">
      </el-table-column>
      <el-table-column
        prop="remarks"
        label="上传要求及说明">
      </el-table-column>
      <el-table-column
        prop="type"
        label="文件上传">
        <template slot-scope="scope">
          <!-- 文件列表 -->
          <fileList :fileList="scope.row.fileList" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DragAndParseUpload from '@/components/upload/dragAndParseUpload.vue'
  export default {
    props: {
      fileList: {
        type: Array,
        default: []
      },
      disabled: Boolean
    },
    components: {
      DragAndParseUpload,
    },
    data() {
      return {
      }
    },
    methods: {},
  }
</script>

<style lang="scss" scoped>

</style>
